import { render } from "./AdminPreguntas.vue?vue&type=template&id=59228a8d&scoped=true"
import script from "./AdminPreguntas.vue?vue&type=script&lang=js"
export * from "./AdminPreguntas.vue?vue&type=script&lang=js"

import "./AdminPreguntas.vue?vue&type=style&index=0&id=59228a8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59228a8d"]])

export default __exports__